import { useTheme } from "../context/ThemeContext";

/**
 * Returns a string based on UI mode. Use the helper for any string that has
 * a "monster" vibe in playful mode.
 *
 *   const t = useCopy();
 *   <h1>{t("Feed me your resume", "Upload your resume")}</h1>
 *
 * Conventions:
 *   - playful: first arg, mascot voice
 *   - promo:   second arg, professional voice
 */
export function useCopy() {
  const { isPro } = useTheme();
  return (playful, promo) => (isPro ? promo : playful);
}
